import {
  createContext,
} from 'react';
import type {
  ReactNode,
} from 'react';

export type HeaderLeftBlockContextValue = {
  /**
   * Установить контент шапки
   * @returns Функция, удаляющая данный блок
   */
  setBlock: (block: ReactNode) => () => void;
};

export const HeaderLeftBlockContext = createContext<HeaderLeftBlockContextValue | null>(null);
